import {createCallable} from './createCallable';

export const questionGenerateQuestionGraphJson = createCallable<
  {
    questionText: string;
    topic?: string;
    difficulty?: number;
    hint?: string;
    options?: string[];
    answer?: string;
    explanation?: string;
  },
  string | null
>('questionGenerateQuestionGraphJson');

export const questionGenerateQuestionWithSeed = createCallable<
  {moduleId: string; seedQuestionId: string; numberOfVariants: number; additionalInfo?: string},
  string[]
>('questionGenerateQuestionWithSeed');

export const questionUserFlag = createCallable<
  {moduleId: string; questionId: string; kind: 'error' | 'out_of_scope'; statusNote?: string},
  unknown
>('questionUserFlag');

export const questionAdminCreate = createCallable('questionAdminCreate');
export const questionAdminCreateFromString = createCallable('questionAdminCreateFromString');
export const questionAdminUpdate = createCallable('questionAdminUpdate');
export const questionChangeStatus = createCallable('questionChangeStatus');
export const questionCheckWithRules = createCallable('questionCheckWithRules');
export const questionCheckWithGpt = createCallable('questionCheckWithGpt');
export const questionCheckRulesDirect = createCallable('questionCheckRulesDirect');
export const questionCheckGptDirect = createCallable('questionCheckGptDirect');
